<template>
  <div class='assertionDetail'>
    <div class='bg' id="bg" v-loading="loading">
      <p class="top-title">Report of  <span>{{ titleName }}</span> </p>
      <p class="top-title top-title-version">Version: <span>{{ version }}</span> </p>
      <div class="tree-box">
        <div class="tree-content" v-for="data in dataTreeList" :key="data" >
          <el-tree 
            accordion 
            highlight-current 
            class="tree" 
            :data="data" 
            :props="defaultProps">
            <template #default="{ node }">
              <div class="node-div">
                <p class="node-lable">{{ node.label }} <span @click.stop="showTable(node)">{{ percentValue(node) }}</span> </p>    
              </div>  
            </template>
          </el-tree>
        </div>
      </div>
      <div class="scroll-box" :style="{right: tableRight}" v-if="isShow">
        <el-scrollbar :max-height="scrollH">
          <div class="line-box" v-for="(line, index) in tableDataList" :key="line">
              <p class="line-p-1"> {{ index + 1 }} </p>
              <p class="line-p-2"> {{ line }} </p>
            </div>
        </el-scrollbar>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getQueryStatus,
  newDownLoadFile
} from "@/request/api";
import { ResourceType } from "@/ginkgo-grpc/jslang/proto/services/rbf_service_pb";
import {
  getUrlData
} from "@/request/axiosApi";
export default {
  name: 'assertionDetail',
  data() {
    return {
      loading: false,
      titleName: '',
      dataTreeList: [],
      levelAssertionValue: 0,
      levelLinesValue: 0,
      version: '',
      tableDataList: [],
      scrollH: 400,
      tableRight: '110px',
      isShow: false,
    }
  },
  computed: {
    percentValue() {
      return node => {
        let assertions = 0
        let lines = 0
        for (const v of node.data.values) {
          assertions += v.value.assertions
          lines += v.value.lines
        }
        if (assertions != 0 && lines != 0) {
          const per = assertions / lines * 100
          const str = per.toFixed(6)
          if (str && str != 0) {
            return str + '%'
          }
        }
        return ""
      }
    },
  },
  mounted() {
    const _this = this
    window.onresize = () => {
      return (() => {
        _this.loadBgLayout()
      })()
    }
  },
  methods: {
    showTable(node) {
      console.log("node = ", node)
      this.isShow = true
      this.tableDataList = []
      for (const vModel of node?.data?.values) {
        const assertStrings = vModel?.value?.assertStrings
        for (const str of assertStrings) {
          if (str) {
            this.tableDataList.push(str)
          }
        }
      }
      this.loadBgLayout()
    },
    circFunc(childList) {
      for (const child of childList) {
        if (child.children.length > 0) {
          this.circFunc(child.children)
        } 
        else {
          const assertions = parseFloat(child?.data?.value?.assertions)
          if(!isNaN(assertions)) {
            this.levelAssertionValue += assertions
          }
          const lines = parseFloat(child?.data?.value?.lines)
          if(!isNaN(lines)) {
            this.levelLinesValue += lines
          }
        }
      }
    },
    getClassifyData(dataArr) {
      const treeDataArray = [] 
      for (const index in dataArr) {
        let childDataList = []
        const model = dataArr[index]
        let curChild = {}
        for (const i in model.list) {
          const name = model.list[i]
          const mod = {
            label: name,
            children: [],
            values: [],
          }
          if (i == 0) {
            if (treeDataArray.length > 0) {
              let isHave = false
              for (const treeList of treeDataArray) {
                const childL = treeList.filter(ch => {
                  return ch.label == name
                })
                if (childL.length > 0) {
                  childDataList = treeList
                  isHave = true
                  break
                }
              }
              if (isHave) {
                  curChild = childDataList[0]
                  curChild.values.push(model)
              } else {
                mod.values.push(model)
                childDataList.push(mod)
                treeDataArray.push(childDataList)
                curChild = mod
              }
            } else {
              mod.values.push(model)
              childDataList.push(mod)
              treeDataArray.push(childDataList)
              curChild = mod
            }
          } 
          else if (i >= 1) {
            const chArr = curChild?.children?.filter(ch => {
              return ch.label == name
            })
            if (i == model.list.length - 1) {
              mod.data = model
            }
            if (chArr?.length == 0) {
              mod.values.push(model)
              curChild.children.push(mod)
              curChild = mod
              
            } else {
              curChild = chArr[0]
              curChild.values.push(model)
            }
          } 
        }
      }
      this.dataTreeList = treeDataArray
    },
    loadBgLayout() {
      const _this = this
      this.$nextTick(() => {
        if (_this.tableDataList.length > 0 ) {
          const bodyH = document.body.clientHeight
          const screenH = screen.availHeight - 400
          const h = bodyH - 400
          if (h < 300) {
            _this.scrollH = 300
          } else {
            if (h > screenH) {
              _this.scrollH = screenH
            } else {
              _this.scrollH = h
            }
          }
          // if (screen.availHeight <= 875 ) {
          //   this.scrollH = '400px'
          // } else {
          //   this.scrollH = '500px'
          // }
        } 
        const bg = document.getElementById("bg");
        if (bg) {
          const wid = bg.offsetWidth
          const bodyW = document.body.clientWidth
          const scapW = (bodyW - wid) / 2 + 20
          _this.tableRight = scapW + 'px'
          if (bodyW < 1120) {
           if ( _this.isShow) {
            _this.isShow = false
           }
          } else {
            if (!_this.isShow) {
              _this.isShow = true
            }
          }
        }
      })
    },
  },

  async created() {
    this.loading = true
    const id = this.$route.params.id
    try {
      const queryData = await getQueryStatus(id, ResourceType.DATA)
      const metricModel = queryData.data
      for (const map of metricModel?.annotationsMap) {
        if (map[0]?.trim().toLocaleLowerCase() == "title") {
          this.titleName = map[1];
        } 
      }
      document.title = `aqua.${this.titleName}`
      const ossKey = metricModel.ossfile?.key
      const fileName = metricModel.ossfile?.originname
      const url = await newDownLoadFile(ossKey, fileName)
      const data = await getUrlData(url)
      console.log("getUrlData === ", data)
      this.version = data?.EdenVersion
      const list = []     
      for (const [key, value] of Object.entries(data)) {  
        if (typeof value == "object") {
          const keys = key.split("/");
          const model = {
            name: key,
            value: value,
            list: keys
          }
          list.push(model)
        }
      }
      this.getClassifyData(list)
    } catch (error) {
      console.log(error)
    }
    this.loading = false
    
    if (this.dataTreeList?.length > 0) {
      const l = this.dataTreeList[0]
      if (l?.length > 0) {
        this.showTable({data: l[0]})
      }
    }
  }
}
</script>
<style lang='less' scoped>

.assertionDetail {
  padding: 60px 100px;
  border-radius: 8px;
}

.bg {
  padding: 35px 70px 10px 70px;
  background-color: #fff;
  min-height: calc(100vh - 200px);
  min-width: 800px;
  max-width: 2300px;
  margin: auto;
  width: 100%;
}

.scroll-box {
  background-color: #fff;
  padding: 10px 10px;
  width: calc(100% / 3);
  max-width: 600px;
  position: fixed;
  top: 150px;
  border: 1px solid #eef2f7;//#eef6ff
  .line-box {
    display: flex;
    margin: 10px 0px;
    align-items: center;
    .line-p-1 {
      font-size: 14px;
    }
    .line-p-2 {
      margin-left: 5px;
      display: flex;
      text-align: left;
      font-size: 14px;
      align-items: center;
      border-radius: 4px;
      background-color: #e9f3ff;
      min-height: 46px;
      padding: 5px 8px;
      width: 100%;
      word-break:break-all; 
    }
  }
}

.top-title {
  color: #000;
  font-size: 16px;
  font-weight: 500;
  padding-left: 15px;
  text-align: left;
  span {
    color: #0052d9;
    font-weight: 600;
  }
}

.top-title-version {
  margin-top: 10px;
  font-size: 14px;
}

.tree-box {
  width: calc(100% / 2);
  display: flex;
  flex-wrap: wrap;
}

.tree-content {
  width: 100%;//calc(100% / 2);
  padding: 30px 0px;  
}

.tree {
  width: 100%;
}

.node-div {
  height: 100%;
  min-width: 120px;
  display: flex;
  align-items: center;
  text-align: left;
  font-size: 16px;
  color: #383838;
  .node-lable {
    align-items: center;
    span {
      color: #0052d9;
      padding-left: 10px;
      font-size: 15px;
      font-weight: 400;
    }
  }
}
  
:deep(.el-tree .el-tree-node) {
  margin-bottom: 10px;
}

:deep(.el-tree-node) {
  position: relative;
  padding-left: 16px;
}

:deep(.el-tree .el-tree-node__content) {
  padding-left: 5px !important;
  padding-top: 5px !important;
  height: 40px !important;
}

:deep(.el-tree .el-tree-node__label) {
  width: 100% !important;
  text-align: left !important;
  height: 40px !important;
  line-height: 40px !important;
  padding: 8px !important;
}

:deep(.el-tree-node__children) {
  padding-left: 16px;
  margin-top: 10px;
}

</style>